import React from 'react';

const AdvancedIvfLabPatternMob = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 428 672" fill="none">
      <g clip-path="url(#clip0_418_4555)">
        <rect width="428" height="672" fill="white" />
        <g opacity="0.53">
          <rect x="402.537" y="356" width="12.4796" height="35.0843" fill="#DDCAEB" />
          <rect x="426.084" y="367.067" width="12.4796" height="35.0843" transform="rotate(90 426.084 367.067)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="21.3203" y="229" width="16.5713" height="46.5873" fill="#DDCAEB" />
          <rect x="52.5879" y="243.695" width="16.5713" height="46.5873" transform="rotate(90 52.5879 243.695)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="381.834" y="466" width="18.208" height="51.1885" fill="#DDCAEB" />
          <rect x="416.189" y="482.146" width="18.208" height="51.1885" transform="rotate(90 416.189 482.146)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="53.1055" y="414" width="13.0934" height="36.8097" fill="#DDCAEB" />
          <rect x="77.8105" y="425.611" width="13.0934" height="36.8097" transform="rotate(90 77.8105 425.611)" fill="#DDCAEB" />
        </g>
        <g opacity="0.61" filter="url(#filter0_d_418_4555)">
          <path d="M379.318 52.4813C326.223 58.9613 305.65 20.1938 302 0H428V81C420.723 60.75 392.513 53.55 379.318 52.4813Z" fill="#7F4A9B" />
        </g>
        <g opacity="0.53">
          <rect x="381.105" y="98" width="13.0934" height="36.8097" fill="#DDCAEB" />
          <rect x="405.811" y="109.611" width="13.0934" height="36.8097" transform="rotate(90 405.811 109.611)" fill="#DDCAEB" />
        </g>
        <g opacity="0.4" filter="url(#filter1_d_418_4555)">
          <path d="M77.4849 545.22C43.7795 549.791 11.3261 530.978 -0.6875 521L-1.00075 672L429 672C413.063 661.445 374.377 640.224 355.119 641.685C335.861 643.147 313.606 643.476 304.886 643.458C274.958 643.123 246.26 612.738 235.653 597.588C228.367 578.599 208.956 561.531 200.161 555.37C176.337 538.395 108.45 541.53 77.4849 545.22Z" fill="#7F4A9B" />
        </g>
        <g opacity="0.53">
          <rect x="38.3203" y="64" width="16.5713" height="46.5873" fill="#DDCAEB" />
          <rect x="69.5879" y="78.6953" width="16.5713" height="46.5873" transform="rotate(90 69.5879 78.6953)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="221.754" y="6" width="8.38796" height="23.5812" fill="#DDCAEB" />
          <rect x="237.582" y="13.4385" width="8.38796" height="23.5812" transform="rotate(90 237.582 13.4385)" fill="#DDCAEB" />
        </g>
      </g>
      <defs>
        <filter id="filter0_d_418_4555" x="282" y="-11" width="166" height="121" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="9" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_4555" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_4555" result="shape" />
        </filter>
        <filter id="filter1_d_418_4555" x="-17" y="500" width="472" height="193" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="5" />
          <feGaussianBlur stdDeviation="10.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_4555" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_4555" result="shape" />
        </filter>
        <clipPath id="clip0_418_4555">
          <rect width="428" height="672" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdvancedIvfLabPatternMob;